import { MultiSelect, MultiSelectProps } from '@mantine/core';
import { FC } from 'react';

// This component is created to avoid styling the multiselect component globally
const StyledMultiSelect: FC<MultiSelectProps> = (props) => (
    <MultiSelect
        {...props}
        classNames={{
            input: 'bg-slate-100 data-[disabled=true]:border-transparent data-[disabled=true]:!bg-slate-100 data-[disabled=true]:!text-slate-400 data-[disabled=true]:!opacity-100',
        }}
    />
);

export default StyledMultiSelect;
